import React from "react";
import styles from "./Link.module.css";
import { ILinkProps } from "../../models/ILinkProps";

const Link = ({
	label,
	href,
	target = "_blank",
	rel = "noopener noreferrer",
	onClick = () => {},
	ref = null,
	className = "",
	size = "md",
	fontFamily = "regular",
	type = "text",
	style = {},
	underline = true,
	...props
}: ILinkProps) => {
	return (
		<a
			className={`${styles.anchor_tag} ${styles["font_" + fontFamily]} ${styles["size_" + size]}  ${styles["type_" + type]} ${underline === false ? styles.no_underline : ""} ${className}`}
			href={href}
			ref={ref}
			target={target}
			rel={rel}
			onClick={onClick}
		>
			{props.children ?? label}
		</a>
	);
};

export default Link;
